export function drawerBar({
  _this,
  myChart,
  data,
  xAxis,
  unit,
  legend,
  yAxis,
  max,
  min,
}) {
  /*       {
         name: '',
        type: 'bar',
        data: [80, 80, 97, 53, 95, 26, 72],
          stack: "总量",???
        itemStyle: {
            normal: {
                color: 'rgba(0,244,255,1)',
            }
        },
    } */
  var option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        lineStyle: {
          type: 'shadow',
          color: '#57617B'
        }
      },   formatter: function (parms) {
        let str = parms[0].axisValue + "</br>"
        parms.map(v => {
          str += `${v.marker} ${v.seriesName}：${_this.$str(v.value)}</br>`
        })
        return str;
      }
    },
    legend: {
      top: '20',
      right: '60',
      width: '90%',
      textStyle: {
        fontSize: 12,
        color: 'rgba(129, 134, 165, 1)',
      },
      data: legend ? legend.data : null,
      itemWidth: 14,
      itemHeight: 10,
    },
    grid: {
      top: '50',
      right: '30',
      bottom: '40',
      left: '55',
    },
    xAxis: [{
      type: 'category',
      data: xAxis,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          fontSize: 12,
          color: 'rgba(129, 134, 165, 1)'
        },
        // formatter: function (value) {
        //   var ret = ""; //拼接加\n返回的类目项
        //   var maxLength = 4; //每项显示文字个数
        //   var valLength = value.length; //X轴类目项的文字个数
        //   var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
        //   if (rowN > 1) //如果类目项的文字大于3,
        //   {
        //     for (var i = 0; i < rowN; i++) {
        //       var temp = ""; //每次截取的字符串
        //       var start = i * maxLength; //开始截取的位置
        //       var end = start + maxLength; //结束截取的位置
        //       //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
        //       temp = value.substring(start, end) + "\n";
        //       ret += temp; //凭借最终的字符串
        //     }
        //     return ret;
        //   } else {
        //     return value;
        //   }
        // },
      },
    }],
    yAxis: yAxis || {
      nameTextStyle: {
        padding: [0, 0, 0, 0]
      },
      type: 'value',
      name: unit || '',
      max: max || null,
      min: min || null,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false,
        lineStyle: {
          fontSize: 12,
          color: 'rgba(129, 134, 165, 1)'
        }
      },
      axisLabel: {
        textStyle: {
          fontSize: 12,
          color: 'rgba(129, 134, 165, 1)'
        }
      },
      splitLine: {
        lineStyle: {
          color: '#E4E7ED',
          type: 'dashed',
        }
      }
    },
    series: data
  };
  if (myChart) myChart.setOption(option)
}



// WEBPACK FOOTER //
// ./src/util/chartsBar.js